import { useEffect, useRef } from 'react'

import { LevelActionType } from '~/bootcamp/types/bootcamp.types'
import { TopicId } from '~/dashboard/utils/learningPath.utils'
import LearningPathAvatarIcon from '~/dashboard/components/LearningPathAvatarIcon'

import { CurriculumGradeLevelType, LevelSource } from '~/curriculum/constants/curriculum.const'

import BootcampLevel from './BootcampLevel'
import MathVaultLevel from './MathVaultLevel'

interface Props {
  levelId: string
  scrollItemId: string
  disableScroll?: boolean
  title: string
  path: string
  isLastVisited: boolean
  isCompleted: boolean
  iconType: LevelActionType
  type: CurriculumGradeLevelType
  onLevelClick: (title: string, id: string) => void
}

const PrerequisiteLevel = ({
  iconType,
  type,
  levelId,
  scrollItemId,
  title,
  path,
  isLastVisited,
  disableScroll,
  isCompleted,
  onLevelClick,
}: Props): React.ReactElement => {
  const avatarRef = useRef<HTMLDivElement>(null)
  const levelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scrollItemId === levelId && levelRef.current && !disableScroll) {
      levelRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [scrollItemId, levelId, disableScroll])

  return (
    <div className="relative">
      <div className="absolute left-1/2 h-4.5 border-l-2 border-white transition-all duration-300" />
      <div className="flex items-center justify-between" ref={levelRef}>
        <div className="w-full mt-4.5">
          {type === CurriculumGradeLevelType.BOOTCAMP && (
            <BootcampLevel
              iconType={iconType}
              isCompleted={isCompleted}
              isGradient
              levelTitle={title}
              onClick={() => onLevelClick(title, levelId)}
              path={path}
              source={LevelSource.PRE_REQUISITE}
              topic={TopicId.NUMBERS}
            />
          )}
          {type === CurriculumGradeLevelType.MATH_VAULT && (
            <MathVaultLevel
              disabled={false}
              globalId={levelId[0] as string}
              isCompleted={isCompleted}
              levelTitle={title}
              onClick={() => onLevelClick(title, levelId)}
              path={path}
              source={LevelSource.PRE_REQUISITE}
              topic={TopicId.NUMBERS}
            />
          )}
        </div>
      </div>
      {isLastVisited && <LearningPathAvatarIcon avatarRef={avatarRef} className="right-0 top-0" />}
    </div>
  )
}

export default PrerequisiteLevel
